import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem('seq', 5, 'ASC'),
	filtro: {
		tipoOuDescricao: {
			value: null,
			default: null,
			label: 'Tipo ou Descrição',
		},
	},
	itensSelecionados: [],
	isSelecionouTodosItensPedido: false,
}
